import React, { useState, useEffect } from 'react';

import { Select } from "@blueprintjs/select";
import { MenuItem, Button, Alignment } from '@blueprintjs/core'

export default ({ list, selected_id, emptyText, onSelect, minimal, icon, intent }) => {

    const TypeSelect = Select.ofType();

    let selected = null;
    if (list && list.length && selected_id) {
        selected = list.find((item) => item.id == selected_id);
    }

    const [type, setType] = useState(selected && selected.title ? selected : {
        id: '0',
        title: emptyText || 'Click here to select'
    });

    const [types, setTypes] = useState(list);

    const filter = (query, data, i, exact) => {
        let title = '';
        if (data.name) title = data.name.toLowerCase();
        if (data.title) title = data.title.toLowerCase();
        query = query.toLowerCase();
        if (exact) return title === query;
        else return title.length == 0 || title.indexOf(query) > -1;
    }

    return types && types.length ? (
        <>
            <TypeSelect
                fill
                items={types}
                itemPredicate={filter}
                itemRenderer={(c, { handleClick }) => {
                    return <MenuItem
                        text={<div dangerouslySetInnerHTML={{ __html: c.title }}></div>}
                        key={`select-${c.id}`}
                        onClick={handleClick}
                    />
                }}
                onItemSelect={(id) => {
                    setType(id);
                    if (onSelect) onSelect(id);
                }}
                popoverProps={{
                    className: 'limit-popup',
                    fill: true
                }}
            >
                <Button
                    fill
                    minimal={minimal ? minimal : false}
                    text={type.title.trim()}
                    icon={icon}
                    rightIcon={icon ? null : "double-caret-vertical"}
                    alignText={Alignment.LEFT}
                    intent={intent}
                />
            </TypeSelect>
        </>
    ) : null

}